<template>
    <div class="card mb-3">
        <div class="card-body">
            <router-link :to="{name: 'users.create'}" class="btn btn-primary mb-3">ایجاد کاربر</router-link>
            <Loading v-if="showLoading" />
            <DataTable :columns="columns" :key="dataTableKey" :rows="rows" v-if="rows.length" :count="count" :url="'User/GetUsers'" :operations="['orders',{show: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}]" />
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    data(){
        return {
            showLoading: true,
            columns: [
                {
                    title: 'نام',
                    field: 'firstName'
                },
                {
                    title: 'نام خانوادگی',
                    field: 'lastName'
                },
                {
                    title: 'کد ملی',
                    field: 'nationalCode'
                },
                {
                    title: 'شماره همراه',
                    field: 'mobile'
                }
            ],
            rows: [],
            count: 0,
            dataTableKey: 0,
        }
    },
    methods: {
        getData(){
            this.$api.post('User/GetUsers',{page: 1,perPage: 10}).then(({data}) => {
                if(data.status){
                    this.rows = data.result.list;
                    this.count = data.result.count;
                    // this.rows.operations = ['users',{update: {class: 'info',title: 'ویرایش',icon: 'ti-pencil'}}];
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>